import { createFileRoute, useNavigate } from '@tanstack/react-router';
import PerfusionDeviceForm from '../../../../Components/PerfusionDeviceForm';
import PerfusionDeviceMessages from '../../../../Lang/perfusion-device';
import { useCanCreatePerfusionDevice, useCanViewPerfusionDevices } from '../../../../Hooks/featurePermission';
import { useFeaturePermissions } from '../../../../Selectors/Permission';

export const Route = createFileRoute('/(main)/_layout/devices/new')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const canViewPerfusionDevices = useCanViewPerfusionDevices();
  const canCreateDevice = useCanCreatePerfusionDevice();
  const featurePermissions = useFeaturePermissions();
  const goToDevices = () => navigate({ to: '/devices' });

  if (!canViewPerfusionDevices) {
    return (
      <div className="perfusion-devices-page perfusion-devices-message">
        {featurePermissions.perfusionDevices
          ? PerfusionDeviceMessages.noListAccess
          : PerfusionDeviceMessages.featureDisabled}
      </div>
    );
  }

  if (!canCreateDevice) {
    return (
      <div className="perfusion-devices-page perfusion-devices-message">
        {PerfusionDeviceMessages.noFormPermission(true)}
      </div>
    );
  }

  return <PerfusionDeviceForm onClose={goToDevices} onSaved={goToDevices} />;
}
